import { render } from "./UnternehmenspraesentationNew.vue?vue&type=template&id=e23ede76"
import script from "./UnternehmenspraesentationNew.vue?vue&type=script&lang=js"
export * from "./UnternehmenspraesentationNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__